import { useState, useEffect } from 'react'

// ----------------------------------------------------------------------

// Tailwind breakpoints (from tailwind.config.js)
const breakpoints = {
  xs: '0px',
  sm: '640px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
  '2xl': '1400px',
}

export default function useResponsive(query, key, start, end) {
  const [matches, setMatches] = useState(false)

  useEffect(() => {
    // Function to create the media query string
    const getMediaQuery = () => {
      if (query === 'up') {
        return `(min-width: ${breakpoints[key]})`
      }
      if (query === 'down') {
        return `(max-width: ${breakpoints[key]})`
      }
      if (query === 'between') {
        return `(min-width: ${breakpoints[start]}) and (max-width: ${breakpoints[end]})`
      }
      if (query === 'only') {
        const nextBreakpoint = Object.keys(breakpoints).findIndex((bp) => bp === key) + 1
        const nextKey = Object.keys(breakpoints)[nextBreakpoint]
        
        if (nextKey) {
          return `(min-width: ${breakpoints[key]}) and (max-width: ${breakpoints[nextKey]})`
        }
        return `(min-width: ${breakpoints[key]})`
      }
      return null
    }

    const mediaQuery = getMediaQuery()
    
    if (!mediaQuery) {
      setMatches(false)
      return undefined
    }

    // Create a media query list
    const mediaQueryList = window.matchMedia(mediaQuery)
    
    // Set initial value
    setMatches(mediaQueryList.matches)
    
    // Define callback for media query change
    const handleMediaQueryChange = (event) => {
      setMatches(event.matches)
    }
    
    // Add event listener
    mediaQueryList.addEventListener('change', handleMediaQueryChange)
    
    // Clean up
    return () => {
      mediaQueryList.removeEventListener('change', handleMediaQueryChange)
    }
  }, [query, key, start, end])

  return matches
}

// Usage examples:
// const isDesktop = useResponsive('up', 'lg')
// const isMobile = useResponsive('down', 'md')
// const isTablet = useResponsive('between', 'sm', 'md')
// const isSmOnly = useResponsive('only', 'sm')
